import { classNames } from 'primereact/utils';

import { IProcessDetails } from '../../../../../../../../../../../../shared/interfaces/IFootprint';
import { IInputMaterial } from '../../../../PcfWizard.type';
import styles from '../../CalculationDetails.module.css';
import ExpandableInjectionMoldingMachineDetails from '../ExpandableInjectionMoldingMachineDetails';
import ExpandableInjectionMoldingWasteTreatmentDetails from '../ExpandableInjectionMoldingWasteTreatmentDetails';
import MaterialDetails from '../MaterialDetails';

type InjectionMoldingProcessCardProps = {
  process: IProcessDetails;
};

const InjectionMoldingProcessCard = ({
  process,
}: InjectionMoldingProcessCardProps): JSX.Element => {
  return (
    <div
      className={classNames('p-4 border-round-2xl flex w-full flex-column gap-5', styles['card'])}
    >
      {/* Process Name */}
      <h5 className='p-0 m-0 font-medium'>{process?.name}</h5>

      {/* Input Material Details */}
      <MaterialDetails inputMaterial={process?.input_materials?.[0] as IInputMaterial} />

      {/* Expandable Machine Details */}
      <ExpandableInjectionMoldingMachineDetails
        machines={process?.machines || []}
        totalMachineEmissions={process.total_machine_emissions}
      />

      {/* Expandable Waste Treatment Details */}
      <ExpandableInjectionMoldingWasteTreatmentDetails wasteManagement={process.waste_management} />
    </div>
  );
};

export default InjectionMoldingProcessCard;
